import { render, staticRenderFns } from "./VariantSifterEnrichedRegionsTable.vue?vue&type=template&id=f9d9ffaa&scoped=true&"
import script from "./VariantSifterEnrichedRegionsTable.vue?vue&type=script&lang=js&"
export * from "./VariantSifterEnrichedRegionsTable.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterEnrichedRegionsTable.vue?vue&type=style&index=0&id=f9d9ffaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d9ffaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9d9ffaa')) {
      api.createRecord('f9d9ffaa', component.options)
    } else {
      api.reload('f9d9ffaa', component.options)
    }
    module.hot.accept("./VariantSifterEnrichedRegionsTable.vue?vue&type=template&id=f9d9ffaa&scoped=true&", function () {
      api.rerender('f9d9ffaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterEnrichedRegionsTable.vue"
export default component.exports